import { render } from "./404.vue?vue&type=template&id=607fcf48"
import script from "./404.vue?vue&type=script&lang=ts"
export * from "./404.vue?vue&type=script&lang=ts"
script.render = render

export default script